import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Input, FormGroup, Label } from "reactstrap";
import { Modal } from "react-bootstrap";
// import NumberFormat from "react-number-format";
import Select from "react-select";
// import DatePicker from "react-datepicker";
import "../myReactSelect.css";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../../baseurl";
// import { Link } from "react-router-dom";
import axios from "axios";
// import SaleTax from "./../Tax/SaleTax/saleTax";
import { GetIp } from "../../../Forms/ShortCutComponents/Get_ip";
// import CreatableSelect from "react-select/creatable";
import { checkPermission } from "../../../../Helper";
import ResponseLoader from "../../../Forms/ShortCutComponents/ResponseLoader";
import { dynamicGlPreferencesCall } from "../../../Forms/ShortFunction/shortFunctions";
import BranchDynamicLov from "../../../Forms/ShortCutComponents/BranchDynamicLov";

// import { getItemSubCategory } from "../../../../../node_backendAS/controllers/lovsController";

export default function ItemForm(props) {
  let defaultdate = new Date();
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [data, setData] = useState({
    empId: "",
    waiterType: "",
    shortDesc: "",
    // defaultRate: "",
    defaultSalesTax: 0,
    showModalItemCategory: false,
    showModalItemSubCategory: false,
    // uom: [],
    itemCatDesc: "",
    itemCatCode: "",
    itemSubCatDesc: "",
    itemSubCatCode: "",
    itemType: "",
    waiterType: "",
    itemCat: "",
    itemCatItemSub: "",
    // itemSubCat: "",
    crDate: defaultdate,
    status: "",
    // defaultRateShow: "",
    showModalAddNew: true,
    activity: props?.propData?.location?.rowData?.referencePk,
  });
  const dynamicBranchSelect = (selectedObj) => {
    setData2({
      ...data2,
      byIdBranchLovVal: selectedObj,
    });
  };
  const dynamicGlFunc = async () => {
    // let id = props.EditData; //propsData?.rowData.id;
    // if (!id) {
    const result = await dynamicGlPreferencesCall();
    console.log(result);
    setData2({
      ...data2,
      showBranchLov: result?.showBranchLov,
      labelBranchLov: result?.labelBranchLov,
      defaultLovVal: result?.defaultLovVal,
    });
    // }
  };

  const toggleAddNew = (showModalAddNew) => {
    setData({ ...data, [showModalAddNew]: showModalAddNew });
    let uomId = data.uom?.id;
    if (uomId) props.toggle(uomId);
    else props.toggle();
  };

  const inputEvent = (e) => {
    // console.log(e.target.value);
    const value = e.target.value;
    const name = e.target.name;
    console.log(Number(value));
    console.log(typeof Number(value));
    if (
      name === "defaultRateShow" &&
      value === "1" &&
      Number(data.defaultRate) <= 0
    ) {
      swal({
        title: "Default rate should be more than 0",
        text: 'Default rate should be more than 0 when display rate on invoice is "Yes" ',
        icon: "warning",
      });
      setData({
        ...data,
        defaultRate: 1,
        [name]: value,
      });
    } else {
      setData({
        ...data,
        [name]: value,
      });
    }
  };

  const selectItemTypeEvent = (...itemTypeField) => {
    setData({
      ...data,
      objEmp: itemTypeField[0],
      itemCat: "",
      itemSubCat: "",
    });
  };

  const selectWaiterTypeEvent = (...waiterTypeField) => {
    setData({
      ...data,
      waiterType: waiterTypeField[0],
      // itemCat: "",
      // itemSubCat: "",
    });
  };

  const [getDataEmpType, setGetDataEmpType] = useState([]);
  const [getDataWaiterType, setGetDataWaiterType] = useState([]);
  const [data2, setData2] = useState({
    byIdBranchLovVal: null,
    byIdBranchLovVal2: null,
    showBranchLov: null,
  });
  useEffect(() => {
    const funCall = async (value) => {
      const openModalCheck = await asyncRollCheck(value);
      if (openModalCheck) {
        toggleAddNew();
        return;
      }
    };
    let itemTypedata = [];
    let waiterdata = [];
    setLoadingResponce(true); // Set loading to true at the start

    // Create a flag to track if all requests are completed
    let completedRequests = 0;
    const totalRequests = 3; // Total number of API calls you are making

    const checkAllRequestsComplete = () => {
      completedRequests++;
      if (completedRequests === totalRequests) {
        setLoadingResponce(false); // Set loading to false once all API calls are completed
      }
    };

    axios
      .post(
        `${baseurl}/lovs/getEmpType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;

        for (let loop = 0; loop < responseData.length; loop++) {
          itemTypedata.push({
            id: responseData[loop]?.PAY_EMPLOYEE_ID,
            value: responseData[loop]?.PAY_EMPLOYEE_ID,
            label: `${responseData[loop]?.FIRST_NAME}`,
          });
        }

        setGetDataEmpType({
          ...getDataEmpType,
          itemTypeOptions: itemTypedata,
        });

        checkAllRequestsComplete(); // Track completion of the request
      })
      .catch((err) => {
        console.log(err);
        checkAllRequestsComplete(); // Even if there's an error, check completion
      });

    axios
      .post(
        `${baseurl}/lovs/getWaiterType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;

        for (let loop = 0; loop < responseData.length; loop++) {
          waiterdata.push({
            id: responseData[loop]?.waiter_type_id,
            label: `${responseData[loop]?.waiter_type_desc}`,
            value: `${responseData[loop]?.waiter_type_desc}`,
          });
        }

        setGetDataWaiterType({
          ...getDataWaiterType,
          waiterTypeOptions: waiterdata,
        });

        checkAllRequestsComplete(); // Track completion of the request
      })
      .catch((err) => {
        console.log(err);
        checkAllRequestsComplete(); // Even if there's an error, check completion
      });

    if (props.EditData > -1) {
      funCall(2);
      let resData;
      let tableId = props.EditData;

      axios
        .post(
          `${baseurl}/pointOfSale/getPosWaiterById`,
          { id: tableId, companyId: companyId, username: username },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then((res) => {
          resData = res.data.data[0];
          let empId = resData["EMPLOYEE_ID"];
          let waiterTypeId = resData["waiter_type_id"];
          let waiterTypeDesc = resData["waiterType"];
          let pNumber = resData["p_number"];
          let empDesc = resData["emp_desc"];
          let shortDesc = resData["remarks"];
          let status = resData["status"];

          let objEmp = {
            id: empId,
            label: empDesc,
          };

          let waiterType = {
            id: waiterTypeId,
            label: waiterTypeDesc,
          };

          let crDate = new Date(resData["creationDate"]);
          setData({
            ...data,
            objEmp,
            waiterType,
            pNumber,
            shortDesc,
            status,
          });
          setData2({
            byIdBranchLovVal: {
              id: resData.sub_inv_id,
              value: resData.sub_inv_id,
              label: resData.fg_sub_inv_desc,
            },
          });

          checkAllRequestsComplete(); // Track completion of the request
        })
        .catch((err) => {
          console.log(err);
          checkAllRequestsComplete(); // Even if there's an error, check completion
        });
    } else {
      funCall(1);
      dynamicGlFunc();
      checkAllRequestsComplete(); // For the dynamicGlFunc call, we also consider it complete
    }
  }, []);

  const asyncRollCheck = async (value) => {
    let pathname = "/AddWaitorForm";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  // useEffect(() => {
  //   let itemTypedata = [];
  //   setLoadingResponce(true);

  //   axios
  //     .post(
  //       `${baseurl}/lovs/getEmpType`,
  //       { companyId: companyId, username: username },
  //       {
  //         headers: {
  //           authorization: token,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       // let mydata = [];
  //       let responseData = response.data.data;

  //       for (let loop = 0; loop < responseData.length; loop++) {
  //         itemTypedata.push({
  //           id: responseData[loop]?.PAY_EMPLOYEE_ID,
  //           value: responseData[loop]?.PAY_EMPLOYEE_ID,
  //           label: `${responseData[loop]?.FIRST_NAME}`,
  //         });
  //       }

  //       setGetDataEmpType({
  //         ...getDataEmpType,
  //         itemTypeOptions: itemTypedata,
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });

  //   axios
  //     .post(
  //       `${baseurl}/lovs/getWaiterType`,
  //       { companyId: companyId, username: username },
  //       {
  //         headers: {
  //           authorization: token,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       let waiterdata = [];
  //       let responseData = response.data.data;
  //       console.log("check it", responseData);
  //       for (let loop = 0; loop < responseData.length; loop++) {
  //         waiterdata.push({
  //           id: responseData[loop]?.waiter_type_id,
  //           label: `${responseData[loop]?.waiter_type_desc}`,
  //           value: `${responseData[loop]?.waiter_type_desc}`,
  //         });
  //       }

  //       setGetDataWaiterType({
  //         ...getDataWaiterType,
  //         waiterTypeOptions: waiterdata,
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });

  //   // if (!props.EditData)
  //   console.log(props.EditData);
  //   if (props.EditData > -1) {
  //     // lovsData();

  //     let resData;
  //     let tableId = props.EditData;
  //     // let  = props?.propData?.location?.rowData?.referencePk
  //     //   ? props?.propDataa?.location?.rowData?.referencePk
  //     //   : props.EditData;

  //     axios
  //       .post(
  //         `${baseurl}/pointOfSale/getPosWaiterById`,
  //         { id: tableId, companyId: companyId, username: username },
  //         {
  //           headers: {
  //             authorization: token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         resData = res.data.data[0];

  //         console.warn("resData :>> ", resData);
  //         let empId = resData["EMPLOYEE_ID"];
  //         let waiterTypeId = resData["waiter_type_id"];
  //         let waiterTypeDesc = resData["waiterType"];
  //         let pNumber = resData["p_number"];
  //         let empDesc = resData["emp_desc"];
  //         let shortDesc = resData["remarks"];
  //         let status = resData["status"];
  //         // let defaultRateShow = resData["ItemRateShow"];
  //         let uomobj, saleTaxobj;
  //         let objEmp = {
  //           id: empId,
  //           label: empDesc,
  //         };

  //         let waiterType = {
  //           id: waiterTypeId,
  //           label: waiterTypeDesc,
  //         };
  //         console.log("objEmp objEmp", objEmp);

  //         let crDate = new Date(resData["creationDate"]);
  //         setData({
  //           ...data,
  //           objEmp,
  //           waiterType,
  //           pNumber,
  //           shortDesc,
  //           // defaultRate: resData["ItemRate"],
  //           status,
  //           // defaultRateShow,
  //         });
  //         setData2({
  //           byIdBranchLovVal: {
  //             id: resData.sub_inv_id,
  //             value: resData.sub_inv_id,
  //             label: resData.fg_sub_inv_desc,
  //           },
  //           // showBranchLov: true,
  //         });
  //         // setGetDataEmpType({
  //         //   objEmp
  //         // })
  //         // getItemCat(itemTypeobj?.id);

  //         // getItemSubCat("", itemCatobj?.id);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   } else {
  //     dynamicGlFunc();
  //   }
  //   setLoadingResponce(false);

  // }, []);

  const getUserIp = async function () {
    let res = await GetIp();
    console.log(res);
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
    setData({
      ...data,
      userIp: res.ip,
      userCountry: res.country,
    });
  };

  const handleSubmitAddItem = async (event) => {
    event.preventDefault();
    console.warn(data);
    setLoadingResponce(true);
    const { byIdBranchLovVal, defaultLovVal } = data2;

    var companyId = localStorage.getItem("companyId");
    const newRecord = { ...data };
    console.log(newRecord);
    console.log(companyId);
    console.log(data.defaultSalesTax);
    // return;
    let { userIp, userCountry } = await getUserIp();
    if (1 == 1) {
      if (props.EditData > -1) {
        // const { id } = this.state;
        let Id = props.EditData;
        // console.log(data.uom.id);
        // console.log(data.itemType.id);
        axios
          .post(
            `${baseurl}/pointOfSale/getUpdatePosWaiter`,
            {
              Id,
              // itemAddE: itemAddE,
              empId: props.EditData,
              // branchId:props.counterBranchId,
              objEmp: data.objEmp,
              waiterType: data.waiterType,
              companyId,
              // itemCat: data.itemCat?.id,
              // itemSubCat: data.itemSubCat?.id,
              waiterType: data.waiterType,
              shortDesc: data.shortDesc,
              pNumber: data.pNumber,
              branchId: byIdBranchLovVal?.id || defaultLovVal,

              // defaultRate: data.defaultRate.toString().replaceAll(",", ""),
              // crDate: data.crDate,
              status: data.status,
              username: username,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )

          .then(function (response) {
            setLoadingResponce(false);
            console.log(response.data);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Successfully Updated!",
                icon: "success",
              }).then((value) => {
                toggleAddNew();
                // thisContex.setState({
                //   tableData:[],
                // })
                // thisContex.updateModalToggle();
                // thisContex.getData();
              });
            }
            // return;
          })
          .catch(function (error) {
            console.log(error);
            setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      } else {
        axios
          .post(
            `${baseurl}/pointOfSale/getAddPosWaiter`,
            {
              empId: data.objEmp.id,
              companyId,
              // branchId:props.counterBranchId,
              waiterType: data.waiterType.id,
              shortDesc: data.shortDesc.toString().replaceAll(",", ""),
              pNumber: data.pNumber,
              // defaultRate: data.defaultRate.toString().replaceAll(",", ""),
              // crDate: data.crDate,
              status: data.status,
              // defaultRateShow: data.defaultRateShow,
              // defaultSalesTax: data.defaultSalesTax.id,
              // uom: data.uom?.id,
              username: username,
              branchId: byIdBranchLovVal?.id || defaultLovVal,

              // itemType: data.itemType?.id,
              // itemCat: data.itemCat?.id,
              // itemSubCat: data.itemSubCat?.id,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            setLoadingResponce(false);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Saved Successfully!",
                // text: "Branch Added",
                icon: "success",
              }).then((value) => {
                toggleAddNew();
              });
            }
          })
          .catch(function (error) {
            console.log("erooor", error);
            setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      }
    } else {
      // setLoadingResponce(false);
      // if (!data.itemType) {
      //   setCheckItemTypeParent(true);
      // }
      // if (!data.itemCat) {
      //   setCheckItemCatParent(true);
      // }
      // if (!data.itemSubCat) {
      //   setCheckItemSubCatParent(true);
      // }
      // if (!data.uom?.id) {
      //   setCheckUomTypeParent(true);
      // }
    }
  };

  return (
    <>
      {loadingResponce ? (
        <ResponseLoader />
      ) : (
        <div>
          <Modal
            show={data.showModalAddNew}
            size="lg"
            onHide={toggleAddNew}
            backdrop="static"
          >
            <Modal.Header
              closeButton
              onClick={toggleAddNew}
              className=" Creative-Invoice-header-styling"
            >
              {console.log("props.EditData", props)}
              <strong>
                <h4> {props.EditData > -1 ? "Update" : "Add"} </h4>
              </strong>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  <div className="row">
                    <div className="col-md-12">
                      <Form name="simpleForm" onSubmit={handleSubmitAddItem}>
                        <div className="row">
                          {data2.showBranchLov && (
                            <div className="col-md-12">
                              <BranchDynamicLov
                                label={
                                  data2.labelBranchLov
                                    ? data2.labelBranchLov
                                    : "Opening Sub-Inventory"
                                } //{data.labelBranchLov}
                                value={data2.byIdBranchLovVal}
                                callBack={(data2) => dynamicBranchSelect(data2)}
                                isRequired={data2.showBranchLov}
                                // isDisabled={disableField}
                              />
                            </div>
                          )}

                          <div
                            className="col-md-12"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Employee :
                            </Label>
                            <Select
                              value={data.objEmp}
                              onChange={selectItemTypeEvent}
                              options={getDataEmpType.itemTypeOptions}
                              required
                              name="empId"
                              isClearable
                              placeholder={"-- Select --"}
                            />
                          </div>
                          <div
                            className="col-md-12"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Phone# :
                            </Label>
                            <Input
                              type="number"
                              className="form-control"
                              name="pNumber"
                              id="pNumber"
                              onChange={inputEvent}
                              required
                              value={data.pNumber}
                            />
                          </div>
                          <div
                            className="col-md-12"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Employee Type :
                            </Label>
                            <Select
                              // key={JSON.stringify(data.waiterType)}
                              value={data.waiterType}
                              onChange={selectWaiterTypeEvent}
                              options={getDataWaiterType.waiterTypeOptions}
                              required
                              name="waiterType"
                              isClearable
                              placeholder={"-- Select --"}
                            />
                          </div>
                          <div
                            className="col-md-12"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Remarks :
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="shortDesc"
                              id="shortDesc"
                              onChange={inputEvent}
                              required
                              value={data.shortDesc}
                            />
                          </div>

                          <div
                            className="col-md-12"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Status :
                            </Label>
                            <Input
                              type="select"
                              className="form-control"
                              name="status"
                              id="status"
                              onChange={inputEvent}
                              required
                              value={data.status}
                            >
                              <option value="" disabled>
                                -- Select --
                              </option>
                              <option translate="no" value="1" selected>
                                Active
                              </option>
                              <option translate="no" value="0">
                                Inactive
                              </option>
                            </Input>
                          </div>
                        </div>
                        <hr
                          style={{
                            border: "1px solid ",
                            marginBottom: "3vh",
                            marginTop: "3vh",
                            borderColor: "E4E5E6",
                          }}
                        />
                        <FormGroup>
                          <Button
                            // onClick={handleSubmitAddItem}
                            // type="submit"
                            className="mr-1 invoiceSubmitButton "
                          >
                            {props.EditData > -1 ? "Update" : "Save"} Changes
                          </Button>
                          <Button
                            onClick={() => toggleAddNew()}
                            className="mr-1"
                            size="sm"
                          >
                            Cancel
                          </Button>
                        </FormGroup>
                      </Form>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
}
